module.exports = __webpack_public_path__ + "media/document-loading.24c6d8fb.mp4";